import { KeyValueCustomSelect } from "@smartsuite/react-ui/lib";
import type { TriggerCandidate } from "../../../../../../types/candidate";
import { useEffect, useState } from "react";
import {
  findInputAndPick,
  pickValueConfigString,
} from "../../../../../../utils/inputs";
import { INPUT_APPLICATION_ID } from "../../../../../../utils/constants";
import type { InputConfig } from "@smartsuite/automation-engine-api";

export const ApplicationReferenceType: React.FC<{
  options: Array<{ value: string; label: string }>;
  onChange: (input: InputConfig) => void;
  config: InputConfig;
  trigger?: TriggerCandidate;
}> = ({ options, onChange, config, trigger }) => {
  const [value, setValue] = useState<string>();

  useEffect(() => {
    if (trigger === undefined) {
      return;
    }
    const applicationId = findInputAndPick(
      trigger.inputs,
      INPUT_APPLICATION_ID,
      pickValueConfigString,
    );
    const configValue =
      config.value?.values[0]?.value.oneofKind === "string"
        ? config.value?.values[0]?.value.string
        : undefined;
    if (applicationId === undefined) {
      return;
    }
    if (configValue === applicationId) {
      setValue(applicationId);
    } else {
      setValue(applicationId);
      onChange({
        ...config,
        value: {
          values: [
            {
              value: {
                oneofKind: "string",
                string: String(applicationId),
              },
            },
          ],
        },
      });
    }
  }, [config]);

  return (
    <KeyValueCustomSelect
      disabled={true}
      value={value}
      showClear={false}
      placeholderArrowStyle="filled-dark"
      options={options}
      onOpenedChange={() => {}}
      onChange={(value) => {}}
    />
  );
};
